/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoleDto } from '../models/RoleDto'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class RolesService {
  /**
   * Method allows you to get roles list
   * @returns RoleDto OK
   * @throws ApiError
   */
  public static getRolesList(): CancelablePromise<RoleDto[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Roles'
    })
  }
}
